var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content voucher-maintenance" },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "span",
            {
              staticStyle: {
                position: "absolute",
                right: "10px",
                "margin-top": "5px"
              }
            },
            [
              _c(
                "el-link",
                {
                  attrs: { type: _vm.lbAccountType },
                  on: { click: _vm.selectAccountSetHandler }
                },
                [_vm._v(_vm._s(_vm.lbAccount))]
              )
            ],
            1
          ),
          _c("business-commission-page", {
            attrs: { "account-set": _vm.accountSet }
          })
        ],
        1
      ),
      _c("account-set-popup", {
        ref: "refAccountSetPopup",
        attrs: {
          visible: _vm.accountSetPopup.visible,
          mode: _vm.accountSetPopup.mode
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.accountSetPopup, "visible", $event)
          },
          select: function(data) {
            return (_vm.accountSet = data)
          },
          cancel: function() {
            return (_vm.accountSetPopup.visible = false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }